import { render, staticRenderFns } from "./ReferenceTagFilter.vue?vue&type=template&id=32e52553&"
import script from "./ReferenceTagFilter.vue?vue&type=script&lang=js&"
export * from "./ReferenceTagFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports